import _ from 'lodash'
import Generic from './generic'

const iconMap = {
  entrepreneurship: require('@src/images/olympiads/entrepreneurship.svg'),
  default: require('@src/images/olympiads/mathematics.svg')
}

const logoMap = {
  entrepreneurship: require('@src/images/logos/brics.svg'),
  default: require('@src/images/logos/brics.svg')
}

class Event extends Generic {
  constructor(attributes) {
    super(attributes)
  }

  get beforePreparatoryTour() { return this.state === 'before_preparatory_tour' }
  get atPreparatoryTour() { return this.state === 'at_preparatory_tour' }
  get afterPreparatoryTour() { return this.state === 'after_preparatory_tour' }
  get beforeTrialTour() { return this.state === 'before_trial_tour' }
  get atTrialTour() { return this.state === 'at_trial_tour' }
  get atMainTour() { return this.state === 'at_main_tour' }
  get afterMainTour() { return this.state === 'after_main_tour' }
  get atFinalTour() { return this.state === 'at_final_tour' }
  get beforeFinalTour() { return this.state === 'before_final_tour' }
  get afterFinalTour() { return this.state === 'after_final_tour' }

  get preparatoryTour() { return this.beforePreparatoryTour || this.atPreparatoryTour || this.afterPreparatoryTour }
  get trialTour() { return this.beforeTrialTour || this.atTrialTour }
  get finalTour() { return this.beforeFinalTour || this.atFinalTour || this.afterFinalTour }

  get currentTour() {
    if (this.preparatoryTour) {
      return 'preparatory'
    } else if (this.trialTour) {
      return 'trial'
    } else if (this.finalTour) {
      return 'final'
    } else {
      return 'main'
    }
  }

  get logo() { return logoMap[this.subject] || logoMap.default }

  get iconSrc() { return iconMap[this.subject] || iconMap.default }

  get subjectName() {
    return I18n.t(`subjects.${this.subject}`)
  }

  get availableTours() { return this.available_tours || [] }

  // get preparatoryTourStartsAt() {
  //   const parsed = Date.parse(this.preparatory_tour_starts_at)
  //   return new Date(parsed)
  // }

  // get preparatoryTourEndsAt() {
  //   const parsed = Date.parse(this.preparatory_tour_ends_at)
  //   return new Date(parsed)
  // }

  // get trialTourStartsAt() {
  //   const parsed = Date.parse(this.trial_tour_starts_at)
  //   return new Date(parsed)
  // }

  // get trialTourEndsAt() {
  //   const parsed = Date.parse(this.trial_tour_ends_at)
  //   return new Date(parsed)
  // }

  // get mainTourStartsAt() {
  //   const parsed = Date.parse(this.main_tour_starts_at)
  //   return new Date(parsed)
  // }

  // get mainTourEndsAt() {
  //   const parsed = Date.parse(this.main_tour_ends_at)
  //   return new Date(parsed)
  // }

  get isAwardsAvailable() { return this.awards_available }
}

export default Event
